// import { i18n } from '@fishx/i18n';
// import { message } from '@whalecloud/fdx';
import get from 'lodash/get';
import { getRequestData } from '@/utils';
import { createSfaLead, qrySfaLeadInfo } from '@/pages/NewConnection/services/leaseLine';

export default {
  namespace: 'leaseLine',
  state: {
    searchTableData: [],
    total: 0,
  },
  effects: {
    // 创建
    *createSfaLead({ payload }, { call }) {
      const response = yield call(createSfaLead, payload);
      const result = getRequestData(response);
      return result;
    },
    // 查询
    *qrySfaLeadInfo({ payload }, { call, put }) {
      const response = yield call(qrySfaLeadInfo, payload);
      const result = getRequestData(response);
      const pageIndex = get(result, 'pageDto.pageIndex');
      if (pageIndex === 1) { // 只有第一页返回的总数才是真正的总数
        yield put({
          type: 'save',
          payload: {
            total: get(result, 'pageDto.totalRecord') || 0,
          },
        });
      }
      yield put({
        type: 'save',
        payload: {
          searchTableData: get(result, 'leadInfoList') || [],
        },
      });
      return result;
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
